import React from 'react'
import useUser from '../../../hooks/use-user'
import useCurrentUser from '../../../hooks/use-current-user'
import UserProfile from '../../user/profile'
import SpinnerContainer from '../../common/spinner-container'
import { get } from 'lodash'

const ProfileScreen = ({
    userId
}) => {
    const { currentUser, isBusy: isAuthenticating } = useCurrentUser()
    const { user, isBusy: isLoading } = useUser({ id: userId || get(currentUser, 'id') })

    if (isAuthenticating || isLoading) {
        return (<SpinnerContainer />)
    }

    return (<UserProfile userId={user.id} />)
}

export default ProfileScreen